//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NoData from "@/components/NoData";
import AddressService from "@/api/addressService";

export default {
  data() {
    return {
      list: []
    };
  },
  computed: {
    scene: function() {
      return this.$route.query.scene;
    }
  },
  mounted() {
    this.query();
  },
  methods: {
    /**
     * 查询地址列表
     */
    query() {
      AddressService.queryList()
        .then(res => {
          this.list = res.data;
        })
        .catch(err => {
          this.$vux.toast.text(err.msg);
        });
    },
    /**
     * 点击新增、编辑地址
     * @param type create edit
     * @param value 地址信息
     */
    clickEdit(type, value) {
      // 进入到地址编辑页
      this.$router.push({
        path: "/editAddress",
        query: {
          type: type,
          value: JSON.stringify(value)
        }
      });
    },
    /**
     * 删除地址
     */
    clickDelete(e) {
      const _this = this;
      this.$vux.confirm.show({
        // 组件除show外的属性
        title: "提示",
        content: "该操作会删除该条地址信息，<br/>是否确认继续？",
        onCancel() {},
        onConfirm() {
          AddressService.delete(e.id)
            .then(res => {
              console.log(res);
              _this.query();
              _this.$vux.toast.text("已删除");
            })
            .catch(err => {
              _this.$vux.toast.text(err.msg);
            });
        }
      });
    },
    /**
     * 点击选择，将当前地址数据缓存，用于上一页提货操作
     */
    clickSelect(e) {
      sessionStorage.setItem("TEMP_SELECT_ADDRESS", JSON.stringify(e));
      this.$router.go(-1);
    }
  },
  components: {
    NoData
  }
};



// WEBPACK FOOTER //
// ./src/views/address/addressList.vue